import React from 'react';

import { Container } from './styles';

const UserDefaultPhoto = ({username, size}) => {
  return <Container size={size} className="user-nophoto">{username?.substring(0,2)}</Container>
}

export default UserDefaultPhoto;